import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "./components/layout";
import ScrollToTop from "./components/common/ScrollToTop";

import {
  HomePage,
  ProductPage,
  FeaturesPage,
  SolutionsPage,
  AICapabilitiesPage,
  IntegrationsPage,
  PricingPage,
  SubscribePage,
  PaymentSuccessPage,
  PaymentFailurePage,
  DemoPage,
  AboutPage,
  FAQPage,
  TermsPage,
  PrivacyPage,
  LoginPage,
  SignupPage,
  ForgotPasswordPage,
  DashboardPage,
  BillingPage,
  ProfilePage,
} from "./pages";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>

          {/* Auth pages - no layout */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          
          {/* Dashboard pages - no layout (has own sidebar) */}
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/dashboard/*" element={<DashboardPage />} />
          <Route path="/billing" element={<BillingPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          
          {/* Marketing pages - with layout */}
          <Route path="/*" element={
            <Layout>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/product" element={<ProductPage />} />
                <Route path="/features" element={<FeaturesPage />} />
                <Route path="/solutions" element={<SolutionsPage />} />
                <Route path="/ai-capabilities" element={<AICapabilitiesPage />} />
                <Route path="/integrations" element={<IntegrationsPage />} />
                {/* <Route path="/pricing" element={<PricingPage />} /> */}
                <Route path="/subscribe" element={<SubscribePage />} />
                <Route path="/payment/success" element={<PaymentSuccessPage />} />
                <Route path="/payment/failure" element={<PaymentFailurePage />} />
                <Route path="/demo" element={<DemoPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/faq" element={<FAQPage />} />
                <Route path="/terms" element={<TermsPage />} />
                <Route path="/privacy" element={<PrivacyPage />} />
              </Routes>
            </Layout>
          } />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
